<div class="xcard" [class.answered]="group.answered">
  <h4 class="x-title">{{ title }}</h4>
  <p class="x-sub" [ngSwitch]="group.kind">
    <ng-container *ngSwitchCase="'suggested'">
      <ng-container *ngIf="example as item">
        We found the unit in {{ count === 1 ? 'its name' : 'each name, for example' }}
        "<ng-container *ngFor="let part of parts(item)"><mark *ngIf="part.found">{{ part.text }}</mark><ng-container *ngIf="!part.found">{{ part.text }}</ng-container></ng-container>".
        {{ count === 1 ? 'Check it, then use it.' : 'Check the list, then use it for all of them.' }}
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'sage-unit'">Aivor doesn't have this unit. Choose one for all of them.</ng-container>
    <ng-container *ngSwitchDefault>
      Choose one Aivor unit for all of them. They may not all be measured the same way, so check the list and change any that differ.
    </ng-container>
  </p>

  <div class="grp-actions">
    <div class="field">
      <label [for]="'unit-group-' + group.key">{{ fieldLabel }}</label>
      <select #groupSelect [id]="'unit-group-' + group.key" [disabled]="saving" (change)="onGroupSelect($any($event.target).value)">
        <option value="" disabled>Choose a unit…</option>
        <option *ngFor="let unit of units" [value]="unit.id">{{ unit.name }} ({{ unit.code }})</option>
      </select>
    </div>
    <button type="button" class="btn btn-teal-gradient use-btn" *ngIf="useLabel" [disabled]="saving" (click)="use()">{{ useLabel }}</button>
  </div>

  <div class="qty-note all-own-note" role="status" *ngIf="allOwnShown">
    <i class="bi bi-info-circle" aria-hidden="true"></i>
    <span>{{ allOwnNote }}</span>
  </div>

  <div class="qty-note" *ngIf="quantityNote as note">
    <i class="bi bi-info-circle" aria-hidden="true"></i>
    <span>{{ note }}</span>
  </div>

  <div class="grp-status" *ngIf="status" [class.ok]="group.answered">
    <i class="bi bi-check-lg" *ngIf="group.answered" aria-hidden="true"></i><span>{{ status }}</span>
  </div>

  <button
    type="button"
    class="link-btn"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="'unit-list-' + group.key"
    (click)="toggle()"
  >
    Choose for each item ({{ count }}) <i class="bi bi-chevron-down chev" [class.up]="open" aria-hidden="true"></i>
  </button>

  <div class="grp-list" *ngIf="open" [id]="'unit-list-' + group.key">
    <div class="grp-search">
      <i class="bi bi-search" aria-hidden="true"></i>
      <input
        type="search"
        [id]="'unit-search-' + group.key"
        [value]="query"
        placeholder="Search by name or code"
        [attr.aria-label]="'Search these ' + count + ' items'"
        autocomplete="off"
        (input)="onSearch($any($event.target).value)"
      />
    </div>

    <p class="muted no-match" *ngIf="!filtered.length">No items match "{{ query.trim() }}".</p>

    <ng-container *ngIf="filtered.length">
      <ul class="grp-rows">
        <li class="grp-row" *ngFor="let item of shownRows; trackBy: trackItem">
          <div class="gr-name">
            <b><ng-container *ngFor="let part of parts(item)"><mark *ngIf="part.found">{{ part.text }}</mark><ng-container *ngIf="!part.found">{{ part.text }}</ng-container></ng-container></b>
            <span class="muted">{{ item.code }}<ng-container *ngIf="ownUnit(item)"> · <span class="own">own unit</span></ng-container></span>
          </div>
          <div class="fixed-type" *ngIf="item.isService; else typePicker">Service</div>
          <ng-template #typePicker>
            <div class="segmented-control" role="group" [attr.aria-label]="'Item type for ' + item.name">
              <button
                type="button"
                class="segmented-option"
                *ngFor="let type of itemTypes"
                [class.active]="item.itemTypeId === type.id"
                [attr.aria-pressed]="item.itemTypeId === type.id"
                [disabled]="saving"
                (click)="chooseType(item, type.id)"
              >
                {{ type.label }}
              </button>
            </div>
          </ng-template>
          <select
            #rowSelect
            class="row-select"
            [id]="'unit-row-' + item.matchId"
            [attr.data-match-id]="item.matchId"
            [attr.aria-label]="'Unit in Aivor for ' + item.name"
            [disabled]="saving"
            (change)="onRowSelect(item, $any($event.target).value)"
          >
            <option value="" disabled>Choose a unit…</option>
            <option *ngFor="let unit of units" [value]="unit.id">{{ unit.name }} ({{ unit.code }})</option>
          </select>
        </li>
      </ul>
      <div class="grp-more">
        <span class="muted">Showing {{ shownRows.length }} of {{ filtered.length }}{{ query.trim() ? ' that match' : '' }}.</span>
        <button type="button" class="link-btn" *ngIf="moreCount > 0" (click)="showMore()">Show {{ moreCount }} more</button>
      </div>
    </ng-container>
  </div>
</div>
